import { Button } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { studioLabelKey } from '../workspaceSelectorData.js';

/**
 * "OPEN A STUDIO" chip group for a workspace card. Each chip deep-links into
 * that studio within the workspace (CT-4941 wires the switch + navigation).
 * Rendered as DS secondary buttons per the design.
 */
function StudioChips({ studios, disabled, onOpenStudio }) {
  const { t } = useTranslation('core-shell');
  if (!studios?.length) return null;

  return (
    <div>
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-content-faint">
        {t('workspaceSelector.openStudio')}
      </p>
      <div className="flex flex-wrap gap-2">
        {studios.map((studio) => (
          <Button
            key={studio.id}
            variant="secondary"
            size="sm"
            disabled={disabled}
            onClick={() => onOpenStudio(studio.id)}
          >
            {t(studioLabelKey(studio.id))}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default StudioChips;
